import styled from 'styled-components'

export const SuccessModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p:last-child {
    color: #898989;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`

export const AuthorizationContainer = styled.div`
  padding: 20px;
  border-radius: 5px;
  background-color: #fffeb5;
  text-align: center;
  margin-bottom: 30px;
`

export const FooterDescription = styled.div`
  text-align: center;
`
